<ng-container *ngIf="!isOnlyHotelsSearch">
    <div *ngIf="!isTight; else tight"
         class="ng-composition">
        <div class="ng-composition-title">
            {{ messages.usuallyIncludedText }}:
        </div>
        <div class="ng-composition-items">
            <div *ngIf="isShowFlight"
                 class="ng-composition-item ng-fly"><span>{{ messages.includedFlight }}</span></div>
            <div *ngIf="isShowTransfer"
                 class="ng-composition-item ng-transfer">
                <span>{{ messages.includedTransfer }}</span>
            </div>
            <div *ngIf="isShowHotel"
                 class="ng-composition-item ng-accommodation">
                <span>{{ messages.includedAccommodation }}</span>
            </div>
            <div *ngIf="isShowMeal"
                 class="ng-composition-item ng-meal"><span>{{ messages.includedMeal }}</span></div>
            <div *ngIf="isShowTourCode"
                 class="ng-composition-item ng-tour-code">
                <span>{{ messages.includedTourCode }}</span>
            </div>
            <div *ngIf="isShowInsurance"
                 class="ng-composition-item ng-insurance">
                <span>{{ messages.includedInsurance }}</span>
            </div>
        </div>
    </div>

    <ng-template #tight>
        <div style="margin: 5px 0;">{{ messages.includedText }}:</div>
        <div class="price_label"
             style="margin-bottom: 20px;">
            <div *ngIf="isShowFlight"
                 class="pr_inc pr_fly pull-left">{{ messages.includedFlight }}
            </div>
            <div *ngIf="isShowTransfer"
                 class="pr_inc pr_transfer pull-left">{{ messages.includedTransfer }}
            </div>
            <div *ngIf="isShowHotel"
                 class="pr_inc pr_hotel pull-left">{{ messages.includedHotel }}
            </div>
            <div *ngIf="isShowMeal"
                 class="pr_inc pr_meal pull-left">{{ messages.includedMeal }}
            </div>
            <div class="clearfix"></div>
        </div>
    </ng-template>
</ng-container>
